import React from "react";
import "./App.css";
import "./brand.css";
import '@fontsource/cormorant-garamond/500.css';
import '@fontsource/cormorant-garamond/600.css';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import './premium.css';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { CartProvider } from './context/CartContext';
import { Toaster } from './components/ui/toaster';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import WebShop from './pages/WebShop';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CatalogPage from './pages/CatalogPage';
import AdminPage from './pages/AdminPage';
import OrderSuccess from './pages/OrderSuccess';
import BankOrderPage from './pages/BankOrderPage';
import { RouteScroll } from './components/RouteScroll';

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <RouteScroll />
        <div className="App flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/webshop" element={<WebShop />} />
              {['/stukature', '/tapete', '/rolo-sistemi', '/zebra-sistemi', '/komarnici'].map(path => (
                <Route key={path} path={path} element={<Navigate to="/webshop" replace />} />
              ))}
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-success" element={<OrderSuccess />} />
              <Route path="/narudzba/:number" element={<BankOrderPage />} />
              <Route path="/o-nama" element={<AboutPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/katalozi" element={<CatalogPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </div>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
